import React, { useMemo } from 'react';

import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import FormIcon from '../../assets/icons/FormIcon';

const FormBreadcrumbs = ({ selectedForm, selectedStep }) => {
  const breadcrumbs = useMemo(() => {
    const initial = { name: 'Forms' }

    if (selectedStep) {
      return [initial, selectedForm, selectedStep];
    }

    if (selectedForm) {
      return [initial, selectedForm];
    }

    return [initial];
  }, [selectedForm, selectedStep]);

  return (
    <div className='drive-breadcrumbs__container'>
      <FormIcon className='m-r-md' color="var(--app-text)" style={{ fontSize: '24px' }} />
      <Breadcrumbs
        separator={<NavigateNextIcon fontSize='small' style={{ color: 'var(--app-text-subtle)' }} />}
        aria-label='breadcrumb'
        maxItems={4}
      >
        {breadcrumbs.map((item) => (
          <div
            key={Math.random()}
            className='drive-breadcrumbs__item'
            style={{ cursor: 'default' }}
          >
            {item?.name || item?.title}
          </div>
        ))}
      </Breadcrumbs>
    </div>
  );
};

export default FormBreadcrumbs;
